<template>
    <div>
        <b-card>
            <div slot="header" class="row w-100 align-items-center">
    
                <!-- Left Side -->
                <div class="col-md-9">
                    <strong class="mr-3">Admin User</strong>

                    <button
                        class="btn btn-sm btn-primary btn-pill ml-3"
                        @click="useradd()"
                        type="button"
                        :disabled="isReadOnly"
                    >
                        Add New
                    </button>

                    <button
                        class="btn btn-sm btn-primary ml-2"
                        @click="refresh()"
                        type="button"
                    >
                        <i class="fa fa-refresh"></i>
                    </button>
                </div>

                <!-- Right Side -->
                <div class="col-md-3 text-right" v-if="issuperAdmin==1">
                    <button
                        class="btn btn-sm"
                        style="color: blue; border: 1px solid red; background-color: transparent;"
                        @click="showmltiselectpopup = true, getuserlistformultiselect()"
                        type="button"
                    >
                        Multiple User Active/Inactive
                    </button>
                </div>

            </div>
            <div id="listloader" v-if="loader">
                <div class="listloader"></div>
            </div>
            <!-- // add user -->
            <div v-if="adduserinfo" id="adduser" style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);" class="mb-1">
                <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                    <input type="hidden" name="chkEditVal" id="chkEditVal" value="0"/>
                    <b-row>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="usertype">User Type</label>&nbsp;<span style="color: red;">*</span>

                                <b-form-select name="usertype" @change="checkuserType(customer.usertype)" v-model="customer.usertype" v-validate="'required'" :class="{ input: true, 'is-invalid': errors.has('form-1.usertype'),}">
                                    <option :value="selectAdmin">--Select UserTpye--</option>
                                    <option value="1">Super Admin</option>
                                    <option value="2">Admin</option>
                                </b-form-select>

                                <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                        <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.usertype')">{{ errors.first("form-1.usertype") }}</i>
                                    </span>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="first name">First Name</label>&nbsp;<span style="color: red;">*</span>
                                <b-form-input type="text" name="first name" v-model="customer.userfirstname" v-validate="'required|alpha|min:3|max:30'" :class="{input: true,'is-invalid': errors.has('form-1.first name'),}" placeholder="Enter First Name">
                                </b-form-input>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i class="fa fa-warning help text-danger"
                                    v-show="errors.has('form-1.first name')">{{ errors.first("form-1.first name") }}</i>
                                </span>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="last name">Last Name</label>&nbsp;<span style="color: red;">*</span>
                                <b-form-input class="input" type="text"
                                name="last name" v-model="customer.userlastname"
                                v-validate="'required|alpha|min:3|max:30'" :class="{
                                    input: true, 'is-invalid': errors.has('form-1.first name'),}" placeholder="Enter Last Name">
                                </b-form-input>

                                <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                        <i class="fa fa-warning help text-danger"
                                        v-show="errors.has('form-1.last name')">{{ errors.first("form-1.last name") }}</i>
                                    </span>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                        <b-form-group>
                            <label for="sysemailid">Email id</label>&nbsp;<span style="color: red;">*</span>

                            <b-form-input class="input" type="text" name="sysemailid" v-model="customer.sysemailid" v-validate="'required|email'"
                            :class="{input: true,'is-invalid': errors.has('form-1.sysemailid'),}" placeholder="Enter Email id">
                            </b-form-input>

                            <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i class="fa fa-warning help text-danger"
                                    v-show="errors.has('form-1.sysemailid')">{{ errors.first("form-1.sysemailid") }}</i>
                                </span>
                            </b-input-group>
                        </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="usermobilenumber">Mobile Number</label>&nbsp;<span style="color: red;">*</span>

                                <b-form-input class="input" type="text" id="usermobilenumber"
                                name="mobile number"  maxlength="10" v-model="customer.usermobilenumber" v-validate="'required|digits:10'"
                                :class="{ input: true,'is-invalid': errors.has('form-1.mobile number'),}"  placeholder="Enter Mobile Number">
                                </b-form-input>

                                <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                        <i class="fa fa-warning help text-danger"
                                        v-show="errors.has('form-1.mobile number')">{{ errors.first("form-1.mobile number") }}</i>
                                    </span>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="Password">Password</label>&nbsp;<span style="color: red;">*</span>

                                <b-form-input class="input" type="password" name="syspassword" minlength="6" maxlength="14" v-model="customer.syspassword"
                                v-validate="'required'" :class="{ input: true, 'is-invalid': errors.has('form-1.syspassword'),}" placeholder="Enter Password">
                                </b-form-input>

                                <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                        <i class="fa fa-warning help text-danger"
                                        v-show="errors.has('form-1.syspassword')">{{ errors.first("form-1.syspassword") }}</i>
                                    </span>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="status">Status</label>&nbsp;<span style="color: red;">*</span>

                                <b-form-select v-model="customer.isactive" name="status" v-validate="'required|'" :class="{ input: true, 'is-invalid': errors.has('form-1.status'),}">
                                    <option :value="selectstatus">--Select--</option>
                                    <option value="1">Active</option>
                                    <option value="0">InActive</option>
                                </b-form-select>

                                <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                        <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.status')">{{ errors.first("form-1.status") }}</i>
                                    </span>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3" v-if="selectedUsertype == 2">
                            <div id="container" style="margin-top:32px;width:230px">
                                <ejs-multiselect id="multi_select2" name="city" placeholder="Select city"
                                v-model="valueCity" :dataSource="optionsCity" @change="selectedCity(valueCity)" :showSelectAll="showSelectAll"
                                selectAllText="Select All" unSelectAllText="unSelect All"
                                :fields="fieldCity" :allowCustomValue="allowCustomValue"
                                enableGroupCheckBox="true" mode="CheckBox"
                                ></ejs-multiselect>
                            </div>
                        </b-col>

                        <b-col sm="3" v-if="valueCity.length > 0">
                        <div id="container" style="margin-top:32px;width:270px;">
                            <ejs-multiselect id="multi_select2"
                            name="warehouse" placeholder="Select WareHouse" v-model="valueWH"
                            :dataSource="optionsWH" @change="selectedWH(valueWH)" :showSelectAll="showSelectAll" selectAllText="Select All"
                            unSelectAllText="unSelect All" :fields="fieldWH"
                            :allowCustomValue="allowCustomValue" enableGroupCheckBox="true"
                            mode="CheckBox">
                            </ejs-multiselect>
                        </div>
                        </b-col>
                    </b-row>
                    <footer class="column has-text-right">
                        <b-button variant="primary" size="md" type="submit">Save</b-button>
                    </footer>
                </b-form>
            </div>


            <!-- // table Listing --> 
            <b-row>
                <b-col md="5" class="my-1" style="display: flex; justify-content: center; align-items: center;">
                     <!-- <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                        <b-input-group>
                            <b-form-input v-model="filter" placeholder="Type to Search">
                            </b-form-input>
                                <b-input-group-append>
                                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                </b-input-group-append>
                        </b-input-group>
                    </b-form-group> --> 

                     <b-form-textarea v-model.trim="searching" style="height:60px;" placeholder="Type to Search : Test" @input="checklenght(searching)"></b-form-textarea>
                     &nbsp;&nbsp;&nbsp;
                    <b-button variant="primary" size="md" @click="searchEmailId()">Search</b-button>

                </b-col>
                <b-col sm="7" class="text-right">
                    <p><b>Total Records :<span style="color:red;">{{totalRows}}</span></b>
                    </p>
                </b-col>
            </b-row>

            <b-table show-empty responsive :items="items" :busy="isBusy" :current-page="currentPage" :fields="fields" :per-page="perPage" :filter="filter"
            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
            :bordered="bordered">
                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>
                <template slot="actions" slot-scope="row">
                    <b-button size="sm" @click="info(row.item, row.index, $event.target)"
                    class="mr-1">Delivery Boy</b-button>
                </template>

                <template slot="admincreator" slot-scope="row">
                    <span v-if="row.item.admincreator != null"
                        :title="row.item.admincreator">
                        {{ row.item.admincreator.substring(0, 10) + ".." }}
                    </span>
                </template>
                <template slot="userfirstname" slot-scope="row">
                {{ row.item.userfirstname }} {{ row.item.userlastname }}
               </template>
                <template slot="createdby" slot-scope="row">
               
               
                 {{ row.item.createdby }} <p> {{ formatDate(row.item.createddate) }}</p>
                </template>
                <template slot="city" slot-scope="row">
                    <button style="background-color:white !important;" @click="viewWarehouse(row.item.city, row.item)" class="btn btn-link nav-link"
                    :title="row.item.city">
                        <span v-if="row.item.city != null" style="color:#1b8eb7">
                        citylist
                        </span>
                    </button>
                </template>
                
                <template slot="usertypeaction" slot-scope="row">
                    {{row.item.user_type == 1 ? "Super Admin" : row.item.user_type == 2 ? "Admin"
                    : row.item.user_type == 3 ? "Coordinator" : "SubCoordinator"}}
                     <p v-if="row.item.hub_id">
                      <label style="
                                    background:#e0e0e0;
                                    padding:2px 6px;
                                    border-radius:4px;
                                    font-size:12px;
                                    font-weight:600;
                                    margin-right:4px;
                                    color:#333;
                                    display:inline-block;">
                                    HubID-
                                </label>
                                    {{ row.item.hub_id }}
                    </p>
                </template>
                       
                <template slot="isactive" slot-scope="row">
            
                    <span @click="!isReadOnly && toggleInfoModal(row.item)" style="cursor:pointer;">
                    <span data-toggle="tooltip" title="InActive" v-if="row.item.isactive === '0'">
                        <span class="badge badge-danger"  :class="{ 'disabled': isReadOnly }" >Inative</span>
                    </span>
                    <span data-toggle="tooltip" title="Active" v-else>
                        <span class="badge badge-success"  :class="{ 'disabled': isReadOnly }" >Active</span>
                    </span>
                    </span>
                    <p>     <b-badge
                    :variant="row.item.pushed_on_cams=='Yes' ? 'success' : 'danger'"
                    class="text-capitalize"
                  >
                    Cams-{{ row.item.pushed_on_cams }}
                  </b-badge></p>
                </template>
  
                <template slot="action" slot-scope="row">
                    <b-button v-if="row.item.user_type == 2 || row.item.user_type == 1"
                    size="sm" @click="editinfoModal(row.item)" data-toggle="tooltip"
                    title="Update User Info" style="background: #b0c4de !important;color: #000 !important;" class="mb-1" :disabled="isReadOnly">
                        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </b-button>
                    &nbsp;
                    <b-button size="sm" v-if="row.item.isactive == 1" @click="editAdmincity(row.item)" data-toggle="tooltip" title="Edit City" class="mb-1"
                    style="background: #b0c4de !important;color: #000 !important;" :disabled="isReadOnly">
                        <i class="fa fa-retweet" aria-hidden="true"></i>
                    </b-button>
                    &nbsp;
                    <div v-if="isReadOnly">
                        <button class="btn btn-sm " data-toggle="tooltip"
                        title="Assign Access" type="button" style="background: #b0c4de !important;color: #000 !important;" :disabled="isReadOnly">
                        <i class="fa fa-external-link" aria-hidden="true"></i>
                        </button>
                    </div>
                    <div v-else>
                        <router-link :to="'/access/' + row.item.sysusermasterid + ' ' + row.item.   user_type" v-if="row.item.isactive == 1">
                            <button class="btn btn-sm " data-toggle="tooltip"
                                title="Assign Access" type="button" style="background: #b0c4de !important;color: #000 !important;">
                                <i class="fa fa-external-link" aria-hidden="true"></i>
                            </button>
                        </router-link>
                    </div>
                    <!-- <router-link :to="'/access/' + row.item.sysusermasterid + ' ' + row.item.   user_type" v-if="row.item.isactive == 1">
                        <button class="btn btn-sm " data-toggle="tooltip"
                            title="Assign Access" type="button" style="background: #b0c4de !important;color: #000 !important;">
                            <i class="fa fa-external-link" aria-hidden="true"></i>
                        </button>
                    </router-link> -->
                    &nbsp;
                    <b-button size="sm" @click="ActivitylogModal(row.item.sysusermasterid)"
                    data-toggle="tooltip" title="Update User Info"
                    style="background: #b0c4de !important;color: #000 !important;">
                        <i class="fa fa-user-o" aria-hidden="true"></i>
                    </b-button>
                    &nbsp;
                    <b-button size="sm" v-if="issuperAdmin==1" @click="changePassword(row.item)"
                    data-toggle="tooltip" title="Change Password"
                    style="background: #b0c4de !important;color: #000 !important;" :disabled="isReadOnly">
                        <i class="fa fa-key" aria-hidden="true"></i>
                    </b-button>
                    &nbsp;
                    <router-link :to="'/pdamoduleaccess/' + row.item.sysusermasterid + ' ' + row.item.user_type" v-if="row.item.isactive == 1">
                    <b-button size="sm" v-if="(issuperAdmin==1 || issuperAdmin==2) && (row.item.user_type == 2 || row.item.user_type == 3 || row.item.user_type == 4)" 
                    data-toggle="tooltip" title="Assign PDA Module Access"
                    style="background: #b0c4de !important;color: #000 !important;">
                    <i class="fa fa-mobile" aria-hidden="true"></i>
                    </b-button></router-link>
                </template>
            </b-table>

            <!-- // pagination -->
            <!-- <b-col md="12" class="my-1 " v-if="this.totalRows > 10">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
            </b-col> -->
            <b-col md="12" class="my-1" >
                <paginate 
                v-model="pageNum"
                :page-count="noofpages"
                :page-range="10"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'">
                </paginate>
            </b-col>   


            <!-- // Active Inactive -->
            <b-modal title="Confirmation Box" v-model="toggleInfo" size="md"
                @ok="toggleInfo = false">
                <template slot="modal-header" slot-scope="{ close }">
                <h5>Confirmation Box</h5>
                </template>

                <template slot="default" slot-scope="{ hide }">
                    <form v-on:submit.prevent="activateInActivateDeliveryAgent()">
                        <div class="modal-background"></div>
                        <div class="modal-card">
                        <section class="modal-card-body">
                            <input type="hidden" v-model="customer.isactive"
                            name="isactive" id="modalIsActiveChk"/>
                            <span>Are you sure you want to change the status?</span>
                        </section>
                        <footer>
                            <b-button variant="primary" size="sm" type="submit">Ok</b-button>
                        </footer>
                        </div>
                    </form>
                </template>
            </b-modal>



            <!-- // Info -->
            <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
                <pre>{{ infoModal.content }}</pre>
            </b-modal>


            <!-- // City wise warehouse ID -->
            <b-modal size="lg" title="Citywise WareHouse ID" v-model="warehouseModal"
            @ok="warehouseModal = false" hide-footer>
        
                <template slot="default" slot-scope="{ hide }">
                    <b-row>
                    <b-col md="12">
                        <div>
                            <div id="listloader" v-if="loader">
                                <div class="listloader"></div>
                            </div>
                            <b-tabs content-class="mt-3">
                                <b-tab id="cityWH" v-for="city in splitCity" :title="city" @click="citywiseWH(city)" :key="city">
                                    <div class="table-responsive container p-3">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                <th>Warehouse Id</th>
                                                <th>Vendor Name</th>
                                                <th>Vendor Address</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="cityWarehouse">
                                                <tr v-for="WHid in cityWarehouse">
                                                <td>{{ WHid.warehouseid }}</td>
                                                <td>{{ WHid.custvendorname }}</td>
                                                <td>{{ WHid.vendoraddress }}</td>
                                                </tr>
                                            </tbody>
                                            <tbody v-if="invalidedata">
                                                <tr>
                                                <td colspan="12">
                                                    {{ invalidedata }}
                                                </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </b-tab>
                            </b-tabs>
                        </div>
                    </b-col>
                    </b-row>

                    <br />

                    <div class="col-md-12 pull-right">
                        <div slot="footer" class="text-right">
                            <b-button size="sm" variant="danger" @click="warehouseModal = false">Close</b-button>
                        </div>    
                    </div>
                </template>
            </b-modal>

            <!-- // Update User Info -->
            <b-modal title="Update User Info" v-model="editAgentMaster"
                @ok="editAgentMaster = false" hide-footer size="xl">
                <template slot="default" slot-scope="{ hide }">
                    <b-form @submit.prevent="validateForm5('form-5')" data-vv-scope="form-5">

                        <b-row>
                            <b-col sm="4">
                                <b-form-group v-if="customer.editusertype == '3'">
                                    <label for="User Type">User Type</label>&nbsp;<span style="color: red;">*</span>
                                    <b-form-select v-model="customer.editusertype" name="editusertype" :class="{input: true, 'is-invalid': errors.has('form-5.editusertype'),}">
                                        <option value="3">Coordinator</option>
                                        <option value="4">Sub-Coordinator</option>
                                    </b-form-select>
                                    <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-5.editusertype')">{{ errors.first("form-5.editusertype") }}</i>
                                        </span>
                                    </b-input-group>
                                </b-form-group> 
                                <b-form-group v-else >
                                    <label for="User Type">User Type</label>&nbsp;<span style="color: red;">*</span>
                                    <b-form-select name="usertype" @change="checkuserTypeedit(customer.editusertype)" v-model="customer.editusertype"
                                    v-validate="'required'" :class="{input: true,'is-invalid': errors.has('form-5.usertype'),}" disabled>
                                        <option :value="selectAdmin">--Select UserTpye--</option>
                                        <option value="1">Super Admin</option>
                                        <option value="2">Admin</option>
                                    </b-form-select>

                                    <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-5.usertype')">{{ errors.first("form-5.usertype") }}</i>
                                        </span>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">
                                <b-form-group>
                                    <label for="first name">First Name</label>&nbsp;<span style="color: red;">*</span>
                                    <b-form-input type="text" name="first name" v-model="customer.first_name" v-validate="'required|alpha|min:3|max:30'" :class="{ input: true, 'is-invalid': errors.has('form-5.first name'),}"
                                        placeholder="Enter First Name">
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-5.first name')">{{ errors.first("form-5.first name") }}</i>
                                        </span>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">
                                <b-form-group>
                                    <label for="last name">Last Name</label>&nbsp;<span style="color: red;">*</span>
                                    <b-form-input class="input" type="text" name="last name"
                                    v-model="customer.last_name" v-validate="'required|alpha|min:3|max:30'"
                                    :class="{input: true,'is-invalid': errors.has('form-5.first name'),}"
                                    placeholder="Enter Last Name">
                                    </b-form-input>

                                    <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-5.last name')">{{ errors.first("form-5.last name") }}</i>
                                        </span>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">
                                <b-form-group>
                                    <label for="sysemailid">Email id</label>&nbsp;<span style="color: red;">*</span>

                                    <b-form-input class="input" type="text" name="email_id" v-model="customer.email_id" v-validate="'required|email'"
                                    :class="{ input: true, 'is-invalid': errors.has('form-5.email_id'),}"
                                    placeholder="Enter Email id">
                                    </b-form-input>

                                    <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-5.email_id')">{{ errors.first("form-5.email_id") }}</i>
                                        </span>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">
                                <b-form-group>
                                    <label for="usermobilenumber">Mobile Number</label>&nbsp;<span style="color: red;">*</span>

                                    <b-form-input class="input" type="text" id="usermobilenumber" name="mobile number"  maxlength="10" v-model="customer.mobile_no"
                                    v-validate="'required|digits:10'" :class="{ input: true,'is-invalid': errors.has('form-5.mobile number'),}" placeholder="Enter Mobile Number">
                                    </b-form-input>

                                    <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-5.mobile number')">{{ errors.first("form-5.mobile number") }}</i>
                                        </span>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">
                                <b-form-group>
                                    <label for="status">Status</label>&nbsp;<span style="color: red;">*</span>

                                    <b-form-select v-model="customer.editisactive" name="status"
                                    v-validate="'required|'" :class="{input: true, 'is-invalid': errors.has('form-5.status'),}">
                                        <option :value="selectstatus">--Select--</option>
                                        <option value="1">Active</option>
                                        <option value="0">InActive</option>
                                    </b-form-select>

                                    <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-5.status')">{{ errors.first("form-5.status") }}</i>
                                        </span>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <!-- <b-col sm="6" v-if="selected_Usertypeedit == 2 || customer.editusertype==2">
                                <div id="container">
                                    <label>Select City</label>&nbsp;<span style="color: red;">*</span>
                                    <ejs-multiselect id="multi_select1" placeholder="Select City"
                                    name="cityid" v-model="updatecityid" :dataSource="optionsCity" @change="selectedCityedit()" :fields="fieldCity" v-validate="'required|'"
                                    :class="{input: true,'is-invalid': errors.has('form-5.cityid'),}">
                                    </ejs-multiselect>
                                </div>
                                <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                        <i class="fa fa-warning help text-danger" v-show="errors.has('form-5.cityid')">{{ errors.first("form-5.cityid") }}</i>
                                    </span>
                                </b-input-group>
                            </b-col>

                            <b-col sm="6" v-if="updatecityid.length > 0 && (selected_Usertypeedit == 2 || customer.editusertype==2)">
                                <div id="container">
                                    <label>Select WareHouse</label>&nbsp;<span style="color: red;">*</span>
                                    <ejs-multiselect id="multiselect" placeholder="Select Warehouse" name="warehouse" v-model="updateWHid" :dataSource="optionsWH" :fields="fieldWH"   
                                     v-validate="'required|'" :class="{input: true, 'is-invalid': errors.has('form-5.warehouse'),}">
                                    </ejs-multiselect>

                                </div>
                                <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                        <i class="fa fa-warning help text-danger" v-show="errors.has('form-5.warehouse')">{{ errors.first("form-5.warehouse") }}</i>
                                    </span>
                                </b-input-group>
                            </b-col> -->

                        </b-row>
                        
                        <div slot="footer" class="text-right">
                            <b-button type="submit" size="sm" class="mr-4" variant="primary">
                            Update</b-button>
                            <b-button size="sm" variant="danger" @click="editAgentMaster = false">cancel</b-button>
                        </div>
                        <div id="listloader" v-if="loader">
                            <div class="listloader"></div>
                        </div>
                    </b-form>
                </template>
            </b-modal>


            <!-- // Edit City And Warehouse -->
            <b-modal size="xl" title="Edit City And Warehouse Id" v-model="editCitymodal"
                @ok="editCitymodal = false" hide-footer>

                <template slot="default" slot-scope="{ hide }">
                    <b-form @submit.prevent="validateForm2('form-2')" data-vv-scope="form-2">
                        <label><b>City</b></label>&nbsp;<span style="color: red;">*</span>
                        <div class="multiselect" ref="multiselect">
                            <div class="select-box" @click="toggleDropdown">
                                <span v-if="editvalueCity.length === 0 && !isselectallCity">Select City</span>
                                <div v-if="editvalueCity.length > 0"  class="selected-cities">
                                    <span v-for="(city, index) in editvalueCity" :key="index" style="font-size: 13px; background: rgb(238, 238, 238); padding: 3px 7px 2px 7px; border-radius: 15px; color: rgb(0, 0, 0); margin: 5px; word-wrap: break-word;">
                                    {{ city }} <i class="fa fa-times" aria-hidden="true" @click="removeCity(city)"></i> 
                                    </span>
                                </div>
                                <div v-if="isselectallCity">
                                    ALL City Selected
                                </div>
                            </div>
                            <div class="dropdown" v-show="showDropdown" ref="dropdown">
                                <div v-if="optionsCity.length>0">
                                    <div style="border-bottom: 1px solid #ddd;" class="pl-3 mt-3">
                                        <input type="checkbox" id="selectAllCheckbox"  v-model="selectAllActive" @change="toggleSelectAll">&nbsp;
                                        <label for="selectAllCheckbox">{{selectAllLabel}}</label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <input type="text" v-model="searchQuery" placeholder="Search City" class="pl-3 searchinput">
                                    </div>
                                  
                                    <div v-for="(city, index) in filteredCities" :key="index" class="checkbox pl-3">
                                        <input type="checkbox" :id="'city'+index" v-model="editvalueCity" :value="city.city" @change="callfunction()" v-if="!isselectallCity">
                                        <label :for="'city'+index">{{ city.city }}</label>
                                        <!-- <span v-if="isselectallCity">&nbsp;
                                            <i class="fa fa-times" aria-hidden="true" @click="removeCityfromList(city)"></i>
                                        </span> -->
                                        
                                    </div>
                                </div>
                                <div class="text-center pt-3 pb-3" v-if="filteredCities.length===0">
                                    No Record Found
                                </div>
                            </div>
                        </div>
                        <span v-if="editvalueCity.length === 0 && !isselectallCity" class="help text-danger">The City field is required</span>
                        <br>
                        <label><b>WareHouse Id</b></label>&nbsp;<span style="color: red;">*</span>
                        <div class="multiselect" ref="multiselect_wh">
                            <div class="select-box" @click="toggleDropdown_wh">
                                <span v-if="editWarehouseid.length === 0 && !isselectallwarehouse">Select WareHouse</span>
                                <div  v-if="editWarehouseid.length>0"  class="selected-cities">
                                    <span v-for="(wh, index) in editWarehouseid" :key="index" style="font-size: 13px; background: rgb(238, 238, 238);padding: 3px 7px 2px 7px; border-radius: 15px; color: rgb(0, 0, 0); margin: 5px; word-wrap: break-word;">{{ wh.name }} <i class="fa fa-times" aria-hidden="true" @click="removeCity_wh(wh)"></i> 
                                    </span>
                                </div>
                                <div v-if="isselectallwarehouse">
                                    ALL Warehouse Selected
                                </div>
                            </div>
                            <div class="dropdown" v-show="showDropdown_wh" ref="dropdown">
                                <div v-if="optionsWH.length>0">
                                    <div style="border-bottom: 1px solid #ddd;" class="pl-3 mt-3">
                                        <input type="checkbox" id="selectAllCheckbox" v-model="selectAllActive_wh" @change="toggleSelectAll_wh">&nbsp;
                                        <label for="selectAllCheckbox">{{selectAllLabel_wh}}</label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <input type="text" v-model="searchQueryWH" placeholder="Search warehouse" class="pl-3 searchinput">
                                    </div>
                                    <div v-for="(wh, index) in optionsWH" :key="index" class="checkbox pl-3" >
                                        <input type="checkbox" :id="'wh'+index" v-model="editWarehouseid" :value="wh" @change="checklength_wh" v-if="!isselectallwarehouse">
                                        <label :for="'wh'+index">{{ wh.name }}</label>
                                    </div>
                                </div>
                                <div class="text-center pt-3 pb-3" v-if="optionsWH.length===0">
                                    No Record Found
                                </div>
                            </div>
                        </div>
                        <span v-if="editWarehouseid.length === 0 && !isselectallwarehouse" class="help text-danger">The WareHouse Id field is required</span>
                        <br><br>
                        <div slot="footer" class="text-right">
                            <b-button type="submit" size="sm" class="mr-4" variant="primary">
                            Update</b-button>
                            <b-button size="sm" variant="danger" @click="editCitymodal = false">
                                cancel</b-button>
                        </div>
                        <div id="listloader" v-if="loader">
                            <div class="listloader"></div>
                        </div>
                    </b-form>
                </template>
            </b-modal>


            <!-- // Activity Log -->
            <b-modal title="Activity Log" v-model="showactivitylogmodal" size="lg" @ok="showactivitylogmodal">
                <b-table show-empty responsive :items="logdata" :fields="logfields"
                  :busy="isBusylog" :filter="filter" :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :bordered="bordered">
                <template slot="name" slot-scope="row">
                    <p v-for="log in logdata">{{log.userfirstname}} {{log.userlastname}}</p>
                </template>
                <template slot="active" slot-scope="row" v-for="log in logdata">
                    <span data-toggle="tooltip" title="InActive" v-if="log.isactive == '0'">
                        <span class="badge badge-danger">Inative</span>
                    </span>
                    <span data-toggle="tooltip" title="Active" v-if="log.isactive == '1'">
                        <span class="badge badge-success">Active</span>
                    </span>
                </template>
                <template slot="hub" slot-scope="row">
                    <p v-for="log in logdata">{{log.hibid ? log.hibid : 'NA'}}</p>
                </template>
                <template slot="lastmodifieddate" slot-scope="row">
                    <div>
                        {{ row.item.lastmodifieddate | ConvertTime12hour() }}
                    </div>
                </template>
                </b-table>
            </b-modal>

            <b-modal title="Change Password" size="md"  v-model="resetPassword"  @ok="resetPassword = false" hide-footer>
            <template slot="default" slot-scope="{ hide }">
              <form @submit.prevent="validateForm4('form-4')" data-vv-scope="form-4">
                <div class="modal-background"></div>
                <div class="modal-card">
                  <section class="modal-card-body">
                    <div class="field">
                      <p class="control">
                        <span style="color: red;"
                          >Strong Passowrd Rules:<br />
      
                          1)Your password must be between 6 to 14 character<br />
                          2)Password must contain at least one lowercase and uppercase
                          character<br />
                          3)Password must contain at least one number<br />
                          4)Password must contain at least one special character
                          <br />
                        </span>
                        <b-form-input
                          class="input"
                          type="text"
                          name="password"
                          minlength="6"
                          maxlength="14"
                          v-model="deliveryagentpassword"
                          v-validate="{
                            required: true,
                            regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,12})/,
                          }"
                          :class="{
                            input: true,
                            'text-danger': errors.has('form-4.password'),
                          }"
                          placeholder="Enter password"
                        />
                        <code
                          v-show="errors.has('form-4.password')"
                          class="help text-danger"
                          >{{ errors.first("form-4.password") }}</code
                        >
                      </p>
                    </div>
                  </section>
                  <footer class="text-right">
                    <div id="overlayModal">
                      <div class="loaderModal"></div>
                    </div>
                    <b-button size="sm" variant="primary" type="submit" class="mr-4"
                      >Update</b-button
                    >
                    <b-button size="sm" variant="danger" @click="cancelPassword()">
                      Cancel
                    </b-button>
                  </footer>
                </div>
              </form>
            </template>
            <template slot="modal-footer" slot-scope="{ cancel }">
              <!-- Emulate built in modal footer ok and cancel button actions -->
              <b-button
                size="sm"
                variant="danger"
                @click="cancel()"
                style="display:none"
              >
                Cancel
              </b-button>
              <!-- Button with custom close trigger value -->
            </template>
          </b-modal>

                      <!-- // Active Inactive -->
                 <b-modal
              v-model="showmltiselectpopup"
              size="lg"
              no-close-on-backdrop
              no-close-on-esc
              hide-footer
          >
              <template #modal-header>
                  <h5>Multiple User Active/Inactive</h5>
              </template>

              <b-card>

                  <div class="mb-2">
                      <b-button
                          size="sm"
                          variant="primary"
                          @click="selectAllUsers"
                      >
                          Select All
                      </b-button>

                      <b-button
                          size="sm"
                          variant="danger"
                          class="ml-2"
                          @click="valuemultipleuser = []"
                      >
                          Clear
                      </b-button>
                  </div>

                  <v-select
                      v-model="valuemultipleuser"
                      :options="multiItems"
                      label="name"
                      multiple
                      :close-on-select="false"
                      :clearable="false"
                      :searchable="true"
                      placeholder="Select Users"
                  >

                      <!-- <template #option="{ name, selected }">
                          <div class="d-flex align-items-center">
                              <input
                                 
                                  :checked="selected"
                                  readonly
                                  class="mr-2"
                              />
                              <span>{{ name }}</span>
                          </div>
                      </template> -->

                  </v-select>

              
                
                        <b-form-select class="mt-4"
                            v-model="userstatus"
                            name="userstatus"
                            v-validate="'required'"
                            :options="statusOptions"
                        >
                            <template #first>
                            <b-form-select-option :value="null">
                                Select Status
                            </b-form-select-option>
                            </template>
                        </b-form-select>

               


                     <div class="text-right mt-4">
                        <b-button :disabled="valuemultipleuser && valuemultipleuser.length == 0"
                            variant="success"
                            @click="saveSelectedUsers();"
                        >
                            Save
                        </b-button>

                        <b-button
                            variant="danger"
                            class="ml-2"
                            @click="showmltiselectpopup = false, valuemultipleuser = []"
                        >
                            Close
                        </b-button>
                    </div>


              </b-card>
          </b-modal>
        </b-card>
    </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from "vue";
import vSelect from "vue-select";
// import "vue-select/dist/vue-select.css";
// import MultiUserActiveInactive from "./multiuseractiveinactive.vue";

export default {
    components: {
        vSelect
    },
    data() {
        return {
          
            name: "adminuser_mr",
            breadcrumbs: [
                {
                text: "Dashboard",
                href: "/dashboard_adv",
                },
                {
                text: "Admin user",
                active: true,
                },
            ],
            showSelectAll: true,
            loader : false,

            //Table List 
            isBusy : false,
            items : [],
            totalRows : 0,
            fields: [
                {key: "sysusermasterid", label: "ID", sortable: true, sortDirection: "desc",},
                { key: "city", label: "City Name", sortable: true,  sortDirection: "desc",tdClass: 'wrap-col' },
                { key: "sysemailid", label: "Email ID", sortable: true,tdClass: 'wrap-col'  },
                { key: "userfirstname", label: "User Name", sortable: true },
               // { key: "userlastname", label: "Last Name", sortable: true },
                { key: "usermobilenumber", label: "mobilenumber", sortable: true },
                { key: "usertypeaction", label: "User Type", sortable: true },
                // { key: "admincreator", label: "Created By", sortable: true },
                                { key: "createdby", label: "Created By", sortable: true },

                { key: "isactive", label: " status" },
                { key: "action", label: " Actions", class: "actionAdmin" },
            ],
            bordered: true,
            totalRows: 0,
            currentPage: 1,
            perPage: 30,
            pageOptions: [5, 10, 15],
            sortBy: null,
            sortDesc: false,
            sortDirection: "asc",
            filter: null,

            //pagination

            noofpages:'',
            pageNum:1,
            listingpageno:1,

            //search
            searching:'',

            // add info 
            adduserinfo : false,
            customer :{},
            // errors : {},

            //city 
            cityData : [],
            valueCity : [],
            optionsCity : [],
            fieldCity: { text: "city", value: "city" },


            // warehouse list
            WHData :[],
            optionsWH  :[],
            valueWH :[],
            fieldWH: { text: "name", value: "id" },

            // Active inactive
            adminactive:'',
            toggleInfo : false,
            sysusermasteridvalue :'',
            usermobilenumbervalue:'',
            // Info 
            infoModal: {
                id: "info-modal",
                title: "",
                content: "",
            },

            // citywise warehoue id 
            warehouseModal:false,
            splitCity :[],
            cityWarehouse: [],
            invalidedata :'',


            // Update user Info
            editAgentMaster:false,
            customer:{},
            sysusermasterid:'',
            updatecityid:[],
            updateWHid:[],
            editCity_update:[],
            cityid:[],
            selected_Usertypeedit:'',
            updatewareshouseid:[],
            valueWHcity:[],


            // Edit city and warehouse
            editCitymodal:false,
            editvalueCity:[],
            edit_Warehouseid :[],
            editWarehouseid:[],
            citywisewarehouse:[],
            showDropdown: false,
            selectAllActive: false,
            showDropdown_wh: false,
            selectAllActive_wh: false,
            editCity :[],
            editWarehouse:[],
            sysId :'',
            //
            isselectallCity:false,
            isselectallwarehouse:false,


            // activitylog
            showactivitylogmodal : false,
            isBusylog : false,
            logdata :[],
            logfields : [
                { key: "name", label: "Name"},
                { key: "sysemailid", label: "Email ID"},
                { key: "usermobilenumber", label: "Mobile Number"},
                { key: "lastmodifiedby", label: "Last Modified By"},
                { key: "hub", label: "Hub Id"},
                { key: "active", label: "Is Active"},
                { key: "lastmodifieddate", label: "Last Modified Data/Time"}
            ],



            searchQuery: '', 
            searchQueryWH:'',
            temp_WHcity:[],

            //password
            deliveryagentpassword:'',
            resetPassword:false,
            passwordvalue:[],
            issuperAdmin:'',
            accessBody:[],
            isReadOnly:false,
            showmltiselectpopup:false,
             multiItems: [],
            valuemultipleuser: [],
            userstatus:null,
            statusOptions: [
            { value: null, text: 'Select Status', disabled: true },
            { value: '1', text: 'Active' },
            { value: '0', text: 'Inactive' }
        ]

        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        console.log("userInfo",userInfo)
        this.issuperAdmin = userInfo.user_type;
        this.accessBody = userInfo.body;
        this.ischeckbodyvalidation();
        this.cityList();
        this.displayData(this.pageNum);
    },
    
    mounted() {
        document.addEventListener('click', this.closeDropdownOnClickOutside);
        document.addEventListener('click', this.closeDropdownOnClickOutside_wh);
    },

    beforeDestroy() {
        document.removeEventListener('click', this.closeDropdownOnClickOutside);
        document.removeEventListener('click', this.closeDropdownOnClickOutside_wh);
    },

    watch: {
        searchQueryWH: function(newVal) {
            console.log('Search query changed:', newVal);
        }
    },

    computed: {
        filteredCities() {
          console.log("optionsCity", this.optionsCity);
            console.log("searchQuery", this.searchQuery);
            const query = (this.searchQuery) ? this.searchQuery.toLowerCase() : '';
            console.log("query", query);

            if (!query) {
                return this.optionsCity;
            }

            return this.optionsCity.filter(city => {
                return city.city && city.city.toLowerCase().includes(query);
            });
    },

    //     filteredwarehouse() {
    

    //     // Check if any of the properties include the search query
    //     return vendorCity.includes(query) || warehouseId.includes(query) || custVendorName.includes(query);
    // }).map(warehouse => ({
    //     name: `${warehouse.warehouseid} ${warehouse.vendorcity} - ${warehouse.custvendorname}`,
    //     id: warehouse.warehouseid
    // }));
    //     },
        
        selectAllLabel() {
            return (this.editvalueCity.length === this.optionsCity.length) || this.isselectallCity===true ? 'Unselect All' : 'Select All';
        },
        selectAllLabel_wh() {
            return (this.editWarehouseid.length === this.optionsWH.length) || this.isselectallwarehouse===true ? 'Unselect All' : 'Select All';
        }
    },

    methods: {
        formatDate(date) {
            if (!date) return ''
            const d = new Date(date)

            return d.toLocaleString('en-IN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
            })
        },
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                if (element.isReadonly==true) {
                this.isReadOnly=true;
                break; 
                }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.isReadonly==true) {
                    this.isReadOnly=true;
                    break; 
                }
                }
            }
            }
        },

        checklenght(value){
            if (value.length==0) {
                this.searching=''
                this.adduserinfo= false;
                this.customer = {};
                this.cityList();
                this.pageNum=1;
                this.displayData(this.pageNum);
            }
        },

        searchEmailId(){
            this.adduserinfo= false;
            this.customer = {};
            this.pageNum=1;
            this.displayData(this.pageNum);
        },

        refresh: function() {
            this.adduserinfo= false;
            this.customer = {};
            this.searching=''
            this.cityList();
            this.pageNum=1;
            this.displayData(this.pageNum);
        },

        clickCallback (pageNum){
            this.displayData(pageNum);
        },

        // Table List
        displayData: function(pageNo) {
            this.items = [];
            this.totalRows = 0;
            this.isBusy = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const obj = {
                sysusermasterid: `${userInfo.sysusermasterid}`,
                usertype: `${userInfo.user_type}`,
                page_no: `${pageNo}`,
                sysemailid : this.searching
            };

            console.log(obj);
            // return false;

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getSystemUserList`, obj)
            .then((result) => {
                this.isBusy = false;
                if (result.body.returnmsg === "Successful") {
                    this.items = result.body.returnvalue;
                    this.totalRows = result.body.totalcount;
                    this.noofpages=parseInt(this.totalRows)/30;
                    this.noofpages=Math.ceil( this.noofpages);
                } else {
                    this.$fire({
                    text: "No records found",
                    type: "warning",
                    timer: 30000,
                    });
                    this.items = [];
                    this.totalRows = 0;
                    this.noofpages='';
                }
            })
            .catch((ex) => {
            console.log("error-----", ex);
            });
        },


        // City List code 
        cityList: function() {
            this.cityData =[];
            this.optionsCity=[];
            this.valueCity =[];
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const cityObj = {
                sysusermasterid: `${userInfo.sysusermasterid}`,
                usertype: `${userInfo.user_type}`,
            };
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getCityList`, cityObj)
            .then((result) => {
                if (result.body.returnmsg === "Successful") {
                    this.cityData = result.body.returnvalue;
                    for (let i = 0; i < this.cityData.length; i++) {
                        if (this.cityData[i].vendorcity!=null || this.cityData[i].vendorcity!="" || this.cityData[i].vendorcity!=undefined || this.cityData[i].vendorcity!='undefined' || this.cityData[i].vendorcity!='null') {
                            let cities = {
                                city: this.cityData[i].vendorcity,
                            };
                            this.optionsCity.push(cities);

                        }
                    }
                } else {
                    this.cityData = result.body.returnvalue;
                    this.optionsCity =[]
                }
            })
            .catch((ex) => {
            console.log("error", ex);
            });
        },

        // Warehouse List
        getWarehouseList: function(value,flag) {
            this.loader = true;
    this.WHData = [];
    this.optionsWH = [];
    this.valueWH = [];
    this.editWarehouseid = [];
    this.updatewareshouseid = [];

    const userdata = localStorage.getItem("userData");
    const userInfo = JSON.parse(userdata);

    let WHObj = {};

    if (
        flag === undefined ||
        flag === null ||
        flag === "" ||
        flag === "undefined" ||
        flag === "null"
    ) {
        const cities = (Array.isArray(value) ? value : [value])
            .map(city => {
                if (typeof city === "string" || typeof city === "number") {
                    return String(city);
                }

                if (city && typeof city === "object") {
                    return city.name || city.city || city.city_name || city.label;
                }

                return null;
            })
            .filter(Boolean);

        WHObj = {
            cities,
            sysusermasterid: `${userInfo.sysusermasterid}`,
            usertype: `${userInfo.user_type}`,
        };
    } else {
        WHObj = {
            isselectallCity: "1",
            sysusermasterid: `${userInfo.sysusermasterid}`,
            usertype: `${userInfo.user_type}`,
        };
    }
            // return false;
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getcitywiseWareHouseList`, WHObj)
            .then((result) => {
                this.loader=false;
                if (result.body.returnmsg === "Successful") {
                    console.log("ok")
                     this.optionsWH = [];

                    this.WHData = result.body.returnvalue;
                    for (let j = 0; j < this.WHData.length; j++) {
                        let WH = {
                            name:this.WHData[j].warehouseid +" " + this.WHData[j].vendorcity.substring(0, 3) + " - " + this.WHData[j].custvendorname,
                            id: this.WHData[j].warehouseid,
                        };
                        this.optionsWH.push(WH);
                    }
                    
                    // if (this.edit_Warehouseid.length>0) {
                    //     this.warehouseselected()
                    // }
                   
                    if (this.edit_Warehouseid.length>0) {
                        for (let j = 0; j < this.WHData.length; j++) {
                            for (var k = 0; k < this.edit_Warehouseid.length; k++) {
                                if (this.WHData[j].warehouseid == this.edit_Warehouseid[k]) {
                                let WH = {
                                    name:
                                    this.WHData[j].warehouseid +
                                    " " +
                                    this.WHData[j].vendorcity.substring(0, 3) +
                                    " - " +
                                    this.WHData[j].custvendorname,
                                    id: this.WHData[j].warehouseid,
                                };
                                this.editWarehouseid.push(WH);
                                }
                            }
                        }
                    }
                    this.updateSelectAllActive();
                    this.updateSelectAllActive_wh();
                
                } else {
                    this.WHData = result.body.returnvalue;
                    this.optionsWH = [];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },


        // Addd Code 
        useradd: function() {
            this.errors.clear("form-1");
            this.adduserinfo =! this.adduserinfo;
        },

        checkuserType: function(value) {
            this.selectedUsertype = value;
        },

        selectedCity: function(value) {
            this.WHData =[];
            this.optionsWH = [];
            this.valueWH =[];
            this.getWarehouseList(value);
        },

        selectedWH: function(value) {
            this.temp_WHcity = [];

            for (var i = 0; i < this.WHData.length; i++) {
                for (var j = 0; j < value.length; j++) {
                if (this.WHData[i].warehouseid == value[j]) {
                    let cityWH = {
                    city: this.WHData[i].vendorcity,
                    warehouseid: value[j].toString(),
                    };

                    this.temp_WHcity.push(cityWH);
                    // console.log("GGGGGG",this.temp_WHcity);
                }
                }
            }
        },

        validateForm(scope) {
            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                if (this.customer.usertype == "2") {
                    this.addAdminInfo();
                } else {
                    this.addSuperadmin();
                }
                }
            });
        },

        addAdminInfo: function() {
            var chkmobileVal = this.chkmobileVal();
            if (chkmobileVal) {
                this.loader = true;
                var userdata = localStorage.getItem("userData");
                var userInfo = JSON.parse(userdata);
                if (this.customer.isactive === "1") {
                    this.customer.isactive = "1";
                } else {
                    this.customer.isactive = "0";
                }

                if (this.valueCity.length > 0) {
                    if (this.valueWH.length > 0) {
                        const admininfoObj = {
                        sysemailid: this.customer.sysemailid,
                        usertype: this.customer.usertype,
                        userfirstname: this.customer.userfirstname,
                        userlastname: this.customer.userlastname,
                        usermobilenumber: this.customer.usermobilenumber,
                        syspassword: this.customer.syspassword,
                        isactive: this.customer.isactive,
                        citywarehousedetails: this.temp_WHcity,
                        // created_by: `${userInfo.sysusermasterid}`,
                        created_by: `${userInfo.sysemailid}`,
                        hub_id:(`${userInfo.hub_id}`== 'null' ? "" : `${userInfo.hub_id}`) ,
                        };

                        // return false;
                        this.$http
                        .post(
                            `${CONSTANTS.MIGRATION_API_URL}/systemUserMasterAdd`,
                            admininfoObj
                        )
                        .then((result) => {
                            this.loader = false;
                            if (result.body.returnmsg === "Successful") {
                            this.$fire({
                                text: "Added Successfully",
                                type: "success",
                                timer: 30000,
                            });
                            this.searching='';
                            this.adduserinfo = false;
                            this.customer = {};
                            this.cityData =[];
                            this.optionsCity=[];
                            this.valueCity =[];
                            this.WHData =[];
                            this.optionsWH = [];
                            this.valueWH = [];
                            this.temp_WHcity = [];
                            this.pageNum=1;
                            this.displayData(this.pageNum);
                            this.cityList();

                            // this.$router.push('/ftl/adminuser_mr');
                            } else {
                                this.$fire({
                                    text: result.body.returnvalue,
                                    type: "error",
                                    timer: 30000,
                                });
                            }
                        })
                        .catch((ex) => {
                            console.log("error", ex);
                        });
                    } 
                    else {
                        this.$fire({
                        text: "Please Select WareHouse Id",
                        type: "warning",
                        timer: 30000,
                        });
                        this.loader = false;
                    }
                } 
                else {
                    this.$fire({
                        text: "Please Select City",
                        type: "warning",
                        timer: 30000,
                    });
                    this.loader = false;
                }
                // }
            } else {
                // Utils.notify("Please enter valid mobile number", "error");
                this.$fire({
                text: "Please Enter Valid Mobile Number",
                type: "warning",
                timer: 30000,
                });
            }
        },

        addSuperadmin: function() {
            var chkmobileVal = this.chkmobileVal();
            if (chkmobileVal) {
                this.loader = true;
                var userdata = localStorage.getItem("userData");
                var userInfo = JSON.parse(userdata);
                if (this.customer.isactive === "1") {
                    this.customer.isactive = "1";
                } else {
                    this.customer.isactive = "0";
                }

                const superadmininfoObj = {
                sysemailid: this.customer.sysemailid,
                usertype: this.customer.usertype,
                userfirstname: this.customer.userfirstname,
                userlastname: this.customer.userlastname,
                usermobilenumber: this.customer.usermobilenumber,
                syspassword: this.customer.syspassword,
                isactive: this.customer.isactive,
                // createdby: `${userInfo.sysusermasterid}`,
                createdby: `${userInfo.sysemailid}`,
                };
                // return false;
                this.$http .post(`${CONSTANTS.MIGRATION_API_URL}/addsuperadmin`,
                    superadmininfoObj)
                .then((result) => {
                    this.loader = false;
                    if (result.body.returnmsg === "Successful") {
                        this.$fire({
                            text: "Added Successfully",
                            type: "success",
                            timer: 30000,
                        });
                        this.searching='';
                        this.adduserinfo = false;
                        this.customer = {};
                        this.cityData =[];
                        this.optionsCity=[];
                        this.valueCity =[];
                        this.WHData =[];
                        this.optionsWH = [];
                        this.valueWH = [];
                        this.pageNum=1;
                        this.displayData(this.pageNum);
                        this.cityList();
                    } else {
                        this.$fire({
                            text: result.body.returnvalue,
                            type: "error",
                            timer: 30000,
                        });
                    }
                })
                .catch((ex) => {
                    console.log("error", ex);
                });
            } else {
                this.$fire({
                text: "Please Enter Valid Mobile Number",
                type: "warning",
                timer: 30000,
                });
            }
        },

//++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
//
        // Active Inactive
        toggleInfoModal: function(value) {
        console.log('toggleInfoModal',value);
            this.adminactive = value.isactive;
            this.sysusermasteridvalue = value.sysusermasterid.toString();
            this.usermobilenumbervalue =value.usermobilenumber;
            this.toggleInfo = !this.toggleInfo;
        },

        activateInActivateDeliveryAgent: function() {

            var activeInactiveVal;
            if (this.adminactive === "1") {
                activeInactiveVal = "0";
            } else {
                activeInactiveVal = "1";
            }
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const customerGetobj = {
                isactive: activeInactiveVal,
                lastmodifiedby: `${userInfo.sysemailid}`,
                sysusermasterid: this.sysusermasteridvalue,
                usermobilenumber:this.usermobilenumbervalue
            };


            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/activateInactivateAdminUser`,
            customerGetobj)
            .then((result) => {
                if (result.body.returnmsg === "Successful") {
                    this.$fire({
                        text: "Status Changed Successfully",
                        type: "success",
                        timer: 30000,
                    });
                    this.searching='';
                    this.pageNum=1;
                    this.displayData(this.pageNum);
                    this.toggleInfo = false;
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                    this.toggleInfo = false;
                }
            })
            .catch((ex) => {
            console.log("error", ex);
            });
        },


        // Info Model
        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`;
            this.infoModal.content = JSON.stringify(item, null, 2);
            this.$root.$emit("bv::show::modal", this.infoModal.id, button);
        },

        resetInfoModal() {
            this.infoModal.title = "";
            this.infoModal.content = "";
        },


        //  citywise warehouse display
        viewWarehouse: function(value, item) {
            this.selectedSystemid = item.sysusermasterid;
            this.cityWarehouse = [];
            this.invalidedata = '';
            this.splitCity = value.split(",");
            this.citywiseWH(this.splitCity[0]);
            this.warehouseModal = true;
        },

        citywiseWH: function(value) {
            this.loader=true;
            this.cityWarehouse = [];
            let userData = localStorage.getItem("userData");
            let userInfo = JSON.parse(userData);
            let obj = {
                city: value,
                sysusermasterid: this.selectedSystemid,
                usertype: `${userInfo.user_type}`,  
            };
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getWarehouseListAgainstCity`, obj).then((result) => {
                this.loader=false;
                if (result.body.returnmsg === "Successful") {
                    this.cityWarehouse = result.body.returnvalue;
                } else {
                    this.invalidedata = result.body.returnvalue;
                    this.cityWarehouse = [];
                }
            })
            .catch((ex) => {
            console.log("error", ex);
            });
        },


        //  Update user Info 
        editinfoModal: function(value) {
            this.valueWHedit =[];
            this.updatecityid =[];
            this.selected_Usertypeedit ='';

            this.sysusermasterid = value.sysusermasterid;
            this.customer.email_id = value.sysemailid;
            this.customer.first_name = value.userfirstname;
            this.customer.sysusermasterid = value.sysusermasterid;
            this.customer.last_name = value.userlastname;
            this.customer.editusertype = value.user_type;
            this.customer.editisactive = value.isactive;
            this.customer.mobile_no = value.usermobilenumber;
            
            var value_cityid = []
            var value_WHid = []
            if (value.city != null || value.city!=undefined || value.city!="") {

                value_cityid = value.city.split(",");
                value_WHid = value.warehouseid.split(",");

                for (var i = 0; i < value_cityid.length; i++) {
                    this.updatecityid.push(value_cityid[i]);
                }
                for (var j = 0; j < value_WHid.length; j++) {
                    this.updateWHid.push(value_WHid[j]);
                }
               this.getWarehouseList(this.updatecityid)
            }
  
            this.editAgentMaster = !this.editAgentMaster;
        },

        checkuserTypeedit(value){
            this.valueWHedit =[]
            this.updatecityid =[]
            if (value==2) {
                this.cityList();
            }
            this.selected_Usertypeedit = value;
        },

        selectedCityedit: function(value) {
            if (this.selected_Usertypeedit == 2 || this.customer.editusertype==2) {
                this.getWarehouseList(this.updatecityid)
            }
        },


        validateForm5(scope) {
            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                this.updateAdinAgent();
                }
            });
        },

        updateAdinAgent: function() {
            this.loader=true;
            var result = [];
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            // this.valueWHcity = [];
            // for (var i = 0; i < this.WHData.length; i++) {
            //     for (var j = 0; j < this.updateWHid.length; j++) {
            //         if (this.WHData[i].warehouseid == this.updateWHid[j]) {
            //             let cityWH = {
            //                 city: this.WHData[i].vendorcity,
            //                 warehouseid: this.updateWHid[j].toString(),
            //             };

            //             this.valueWHcity.push(cityWH);
            //         }
            //     }
            // }

            // if (this.customer.editusertype==2) {
            //     if (this.valueWHcity.length==0) {
            //         this.$fire({
            //             text: "Please select WareHouse",
            //             type: "warning",
            //             timer: 30000,
            //         });
            //         this.loader=false;
            //         return false
            //     }

            //     this.passwObj = {
            //         sysemailid: this.customer.email_id,
            //         userfirstname: this.customer.first_name,
            //         userlastname: this.customer.last_name,
            //         user_type: this.customer.editusertype,
            //         citywarehousedetails: this.valueWHcity,
            //         usermobilenumber: this.customer.mobile_no,
            //         sysusermasterid: this.customer.sysusermasterid,
            //         isactive : this.customer.editisactive
            //     };
            // }
            // else {
                this.passwObj = {
                    sysemailid: this.customer.email_id,
                    userfirstname: this.customer.first_name,
                    userlastname: this.customer.last_name,
                    user_type: this.customer.editusertype,
                    usermobilenumber: this.customer.mobile_no,
                    sysusermasterid: this.customer.sysusermasterid,
                    isactive : this.customer.editisactive,
                    lastmodifiedby : `${userInfo.userfirstname}` + ' '+`${userInfo.userlastname}`
                };
            // }
            
     
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/updateAdminUser`, this.passwObj)
            .then((result) => {
                this.loader=false;
                if (result.body.returnmsg === "Successful") {
                    this.$fire({
                    text: "Updated Successfully",
                    type: "success",
                    timer: 30000,
                    });
                    this.searching='';
                    this.editAgentMaster = !this.editAgentMaster;
                    this.customer = {};
                    this.pageNum=1;
                    this.displayData(this.pageNum);
                } else {
                    this.$fire({
                    text: result.body.returnvalue,
                    type: "error",
                    timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
    

        // Edit city and warehouse
        editAdmincity: function(value) {
            this.showDropdown= false;
            this.selectAllActive =false;
            this.showDropdown_wh = false;
            this.selectAllActive_wh = false;
            this.editvalueCity = [];
            this.editvalueWH = [];
            this.optionsWH = [];
            this.citywisewarehouse = [];
            this.editCity =[];
            this.editWarehouse =[];
            this.edit_Warehouseid = [];
            this.editWarehouseid =[];
            this.isselectallCity= false;
            this.isselectallwarehouse =false;
            
            this.sysId = value.sysusermasterid.toString();

            if (value.city != null) {
                this.editCity = value.city.split(",");
                this.editWarehouse = value.warehouseid.split(",");

                for (var i = 0; i < this.editCity.length; i++) {
                    if (this.editCity[i]==null || this.editCity[i]==undefined || this.editCity[i]=="") {
                        console.log("---")
                    }
                    else{
                        this.editvalueCity.push(this.editCity[i]);
                    }
                }

                for (var j = 0; j < this.editWarehouse.length; j++) {
                    this.edit_Warehouseid.push(this.editWarehouse[j]);
                }
                this.getWarehouseList(this.editvalueCity)
            } else {
                this.edit_Warehouseid = [];
                this.cityList();
            }
            this.updateSelectAllActive();
            this.updateSelectAllActive_wh();
            this.editCitymodal = true;
        },

        // City

        toggleDropdown() {
            this.showDropdown = !this.showDropdown;
        },

        closeDropdownOnClickOutside(event) {
            const multiselect = this.$refs.multiselect;
            if (!(multiselect && multiselect.contains(event.target))) {
                this.showDropdown = false;
            }
        },

        removeCity(city) {
            const index = this.editvalueCity.indexOf(city);
            if (index !== -1) {
                this.editvalueCity.splice(index, 1);
            }
            this.editWarehouse =[];
            this.edit_Warehouseid = [];
            this.editWarehouseid =[];
            this.getWarehouseList(this.editvalueCity)
            this.updateSelectAllActive();
        },

        // removeCityfromList(city){
        //     console.log(city)
        //     var citylist = []
        //     const index = this.optionsCity.indexOf(city);
        //     if (index !== -1) {
        //         this.optionsCity.splice(index, 1);
        //     }
        //     this.optionsCity.forEach(element => {
        //         citylist.push(element.city)
        //     });
        //     this.editvalueCity = citylist
        //     this.isselectallCity=false
        //     this.editWarehouse =[];
        //     this.edit_Warehouseid = [];
        //     this.editWarehouseid =[];
        //     this.getWarehouseList( this.editvalueCity )
        // },

        toggleSelectAll() {
            if (this.selectAllActive) {
                this.editWarehouse =[];
                this.edit_Warehouseid = [];
                this.editWarehouseid =[];
                this.editvalueCity = [];
                this.allCityselect();
                this.isselectallwarehouse=false;
                this.selectAllActive_wh = false;
                // this.editvalueCity = this.optionsCity.map(city => city.city);
                // this.getWarehouseList(this.editvalueCity)
            } else {
                this.isselectallwarehouse=false;
                this.selectAllActive_wh = false;
                this.isselectallCity = false;
                this.editWarehouse =[];
                this.edit_Warehouseid = [];
                this.editWarehouseid =[];
                this.editvalueCity = [];
                this.optionsWH=[]
            }
        },

        updateSelectAllActive() {
            if (this.isselectallCity == true) {
                this.selectAllActive = true
            }
            else{
                this.selectAllActive_wh = false;
                this.isselectallwarehouse=false;
                this.isselectallCity = false;
                this.selectAllActive = this.editvalueCity.length === this.optionsCity.length;   
            }
        },

        allCityselect(){
            this.isselectallCity = true;
            this.editWarehouse =[];
            this.edit_Warehouseid = [];
            this.editWarehouseid =[];
            this.editvalueCity = [];
            this.getWarehouseList(this.editvalueCity,this.isselectallCity)
        },

        // Warehouse 

        toggleDropdown_wh() {
            this.showDropdown_wh = !this.showDropdown_wh;
        },

        closeDropdownOnClickOutside_wh(event) {
            const multiselect = this.$refs.multiselect_wh;
            if (!(multiselect && multiselect.contains(event.target))) {
                this.showDropdown_wh = false;
            }
        },

        removeCity_wh(wh) {
            const index = this.editWarehouseid.indexOf(wh);
            if (index !== -1) {
                this.editWarehouseid.splice(index, 1);
            }
            this.updateSelectAllActive_wh();
        },

        toggleSelectAll_wh() {
            if (this.selectAllActive_wh) {
                this.editWarehouseid = [];
                this.isselectallwarehouse=true;
                // this.editWarehouseid = [...this.optionsWH];
            } else {
                this.isselectallwarehouse=false;
                this.editWarehouseid = [];
            }
        },

        updateSelectAllActive_wh() {
            if (this.isselectallwarehouse==true) {
                this.selectAllActive_wh = true;
            } else {
                this.isselectallwarehouse=false;
                this.selectAllActive_wh = this.editWarehouseid.length === this.optionsWH.length;   
            }
        },


        checklength_wh(){
            if (this.editWarehouseid.length == this.optionsWH.length) {
                this.selectAllActive_wh = true
            }
            else{
                this.selectAllActive_wh = false
            }
        },

        callfunction(){
            this.editWarehouse =[];
            this.edit_Warehouseid = [];
            this.editWarehouseid =[];  
            this.getWarehouseList(this.editvalueCity)
        },

        validateForm2(scope) {
            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                this.updateCityWH();
                }
            });
        },

        updateCityWH: function() {
            this.loader=true;
            let userData = localStorage.getItem("userData");
            let userInfo = JSON.parse(userData);
            if (this.editvalueCity.length === 0 && this.isselectallCity === false) {
                this.$fire({
                    text: "Please Select City",
                    type: "warning",
                    timer: 30000,
                });
                this.loader=false;
                return false;
            }
            if (this.editWarehouseid.length === 0 && this.isselectallwarehouse === false) {
                this.$fire({
                    text: "Please Select Warehouse Id",
                    type: "warning",
                    timer: 30000,
                });
                this.loader=false;
                return false;
            }

            if ((this.isselectallCity === false && this.isselectallwarehouse === false)||(this.isselectallCity === true && this.isselectallwarehouse === false)) {
                for (var i = 0; i < this.WHData.length; i++) {
                    for (var j = 0; j < this.editWarehouseid.length; j++) {
                        if (this.WHData[i].warehouseid == this.editWarehouseid[j].id) {
                            let cityWH = {
                                city: this.WHData[i].vendorcity,
                                warehouseid: this.editWarehouseid[j].id.toString(),
                            };

                            this.citywisewarehouse.push(cityWH);
                        }
                    }
                }
            }
            

            if ((this.isselectallCity === true && this.isselectallwarehouse === true) || (this.isselectallCity === false && this.isselectallwarehouse === true)) {
                for (var i = 0; i < this.WHData.length; i++) {
                    for (var j = 0; j < this.optionsWH.length; j++) {
                        if (this.WHData[i].warehouseid == this.optionsWH[j].id) {
                            let cityWH = {
                                city: this.WHData[i].vendorcity,
                                warehouseid: this.optionsWH[j].id.toString(),
                            };

                            this.citywisewarehouse.push(cityWH);
                        }
                    }
                }
            }
            
            let obj = {
                citywarehousedetails: this.citywisewarehouse,
                sysusermasterid: this.sysId.toString(),
            };
            console.log("---------",obj)
            // return false;
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/updateCityAndWarehouse`, obj)
            .then((result) => {
                this.loader=false;
                if (result.body.returmmsg === "Successful") {
                    this.$fire({
                        text: "City and Warehouse Id Updated Successfully",
                        type: "success",
                        timer: 30000,
                    });
                    this.searching='';
                    this.pageNum=1;
                    this.displayData(this.pageNum);
                    this.editCitymodal = false;
                    this.showDropdown= false;
                    this.editvalueCity= [];
                    this.selectAllActive =false;
                    this.showDropdown_wh = false;
                    this.selectAllActive_wh = false;
                    this.editvalueCity = [];
                    this.editvalueWH = [];
                    this.optionsWH = [];
                    this.citywisewarehouse = [];
                    this.editCity =[];
                    this.editWarehouse =[];
                    this.edit_Warehouseid = [];
                    this.editWarehouseid =[];
                    this.isselectallCity= false;
                    this.isselectallwarehouse =false;
                } else {
                    this.$fire({
                        text: result.body.returmmsg,
                        type: "warning",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },


        // Activity log
        ActivitylogModal(sysid){
            document.getElementById("overlay").style.display = "block";
            console.log(sysid)
            const obj = {
                sysusermasterid : sysid
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getSystemUserActivityLog`,obj)
            .then((result) => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                    this.logdata = result.body.returnvalue;
                    this.showactivitylogmodal = true;
                }else{
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                 }
            })
        },



        /// phone number
        chkmobileVal() {
            var chkValidate = true;
            // var chknumb = /^[789]{1}\d{9}$/
            var chknumb = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
            var usermobilenumber = document.getElementById("usermobilenumber").value;
            if (
                usermobilenumber.trim() === "0000000000" ||
                usermobilenumber.trim().length < 10
            ) {
                chkValidate = false;
                return false;
            } else if (
                usermobilenumber.trim() != "" &&
                !usermobilenumber.trim().match(chknumb)
            ) {
                chkValidate = false;
                return false;
            }
            return (chkValidate = chkValidate);
        },

        changePassword(value) {
            console.log("Value",value);
           
            this.passwordvalue = [];
            this.passwordvalue = value;
            this.deliveryagentpassword = '';
            this.resetPassword = true;
        },

        cancelPassword(){
            this.passwordvalue = [];
            this.deliveryagentpassword = '';
            this.resetPassword = false;
        },

        validateForm4(scope) {
            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                this.changeVehiclePassword();
                }
            });
        },
        
        changeVehiclePassword: function() {
            document.getElementById("overlayModal").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var passwObj = {
                superadminid: userInfo.sysusermasterid,
                sysusermasterid: this.passwordvalue.sysusermasterid,
                syspassword: this.deliveryagentpassword.trim(),
            };
            this.$http.post(
                `${CONSTANTS.MIGRATION_API_URL}/changeUsersPasswordBySuperAdmin`,
                passwObj
                )
                .then((result) => {
                // console.log("error",result);
                document.getElementById("overlayModal").style.display = "none";
                if (result.body.returnmsg == "Successful") {
                    this.$fire({
                    text: "Password Updated Successfully",
                    type: "success",
                    timer: 300000,
                    });
                    this.searching='';
                    this.deliveryagentpassword = ''
                    this.resetPassword = false;
                    this.pageNum=1;
                    this.displayData(this.pageNum);
                } else {
                    this.$fire({
                    text: result.body.returnvalue,
                    type: "error",
                    timer: 300000,
                    });
                }
                })
                .catch((ex) => {
                console.log("error", ex);
                });
        },

        getuserlistformultiselect: function() {
            this.valuemultipleuser = []
            this.userstatus = null
            const userdata = localStorage.getItem("userData");

            if (!userdata) {
                console.error("userData not found");
                return;
            }

            const userInfo = JSON.parse(userdata);

            const obj = {
                sysusermasterid: userInfo.sysusermasterid,
                usertype: userInfo.user_type,
            };

            console.log("Request:", obj);

            this.$http
                .post(
                    `${CONSTANTS.MIGRATION_API_URL}/getuserlistformultiselect`,
                    obj
                )
                .then((result) => {
                    console.log("API Response:", result.body);

                    if (
                        result.body &&
                        result.body.returnmsg === "Successful"
                    ) {
                        const itemdata =
                            result.body.returnvalue || [];
                        console.log(itemdata)
                        

                         this.multiItems = itemdata.map((item) => ({
                            name:
                                `${item.sysusermasterid || ""}-${item.userfirstname || ""} ${item.userlastname || ""}-${item.usermobilenumber || ""}-[${item.isactive == '1' ? 'Active' : 'Inactive'}]`.trim(),
                            id: item.sysusermasterid,
                        }));

                        console.log(
                            "Loaded Users:",
                            this.multiItems
                        );
                    } else {
                        this.multiItems = [];

                        this.$fire({
                            text: "No records found",
                            type: "warning",
                            timer: 3000,
                        });
                    }
                })
                .catch((error) => {
                    console.error(
                        "Error loading users:",
                        error
                    );

                    this.multiItems = [];

                    this.$fire({
                        text: "Failed to load users",
                        type: "error",
                        timer: 3000,
                    });
                });
        },

        selectAllUsers() {
            this.valuemultipleuser = [...this.multiItems];
        },

        saveSelectedUsers() {
            // valuemultipleuser
            if (this.userstatus == '0') {
                this.$bvModal
                    .msgBoxConfirm(
                    'Are you sure you want to mark this user as inactive? This user will not be available for future operations.',
                    {
                        title: 'Confirmation',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        centered: true,
                        size: 'md'
                    }
                    )
                    .then(value => {
                    if (value) {
                        this.updateUserStatus();
                    }
                    });

                return;
            }
                        // Active selected
            this.updateUserStatus();
            
        },

        updateUserStatus(){

            if(this.userstatus === null || this.userstatus == ''){
                this.$fire({
                    text: "please select status as well",
                    type: "warning",
                    timer: 3000,
                });
                return;
            }
            
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const selectedIds =
                this.valuemultipleuser.map(
                    user => user.id
                );

            console.log("Selected User IDs:", selectedIds);

            const payload = {
                userids: selectedIds,
                userstatus: this.userstatus,
                lastmodifiedby: `${userInfo.sysemailid}`
            };

            this.$http
                .post(
                    `${CONSTANTS.MIGRATION_API_URL}/multipleUserStatusUpdate`,
                    payload
                )
                .then(result => {
                    if(result.body.returnmsg == 'Successful'){
                        this.$fire({
                        text: "Updated Successfully",
                        type: "success",
                        timer: 3000,
                        });
                        this.displayData(1);
                        this.showmltiselectpopup = false;
                        
                    }else{
                        this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 3000,
                        });
                    }
                });

                
            }
     
    },
}
</script>

<style scoped>
    .searchinput, .searchinput:focus-visible, .searchinput:focus {
        border: 1px solid #cdc2c2;
        border-radius: 6px;
        padding: 8px;
        margin-bottom: 10px;
        width: 80%;
        outline: none; /* Remove default focus outline */
    }

    .searchinput::placeholder {
        color: #999; /* Placeholder text color */
        font-size: 15px;
        font-family: auto;
    }
    .wrap-col {
  white-space: normal !important;
  word-break: break-word;
  max-width: 180px;
}

.vs__dropdown-menu {
    z-index: 99999 !important;
}

.vs__dropdown-option--selected {
    background: #eef6ff;
    font-weight: 600;
}

.vs__selected {
    margin: 2px;
}

</style>
